var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Inactive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 31,
    viewBox: "0 0 89 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 89,
    height: 31,
    rx: 15.5,
    fill: "#ce3939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(-937 -518.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 56,
    height: 20,
    transform: "translate(964 524.5)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "Inactive-2",
    "data-name": "Inactive",
    transform: "translate(992 538.5)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.74,
    y: 0
  }, "Inactive"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(946 528.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActive);
export default __webpack_public_path__ + "static/media/InActive.38fd187692de7c2985a464e9921c4753.svg";
export { ForwardRef as ReactComponent };